class TimerService {
  constructor() {
    let timers = [];
    this.timers = () => {
      return timers;
    };
    this.getTimerById = timerId => {
      return timers.find(({ id }) => timerId === id);
    };
    this.registerTimer = timer => {
      timers = timers.concat(timer);
      return this;
    };
    this.registerTimers = timer => {
      return this.registerTimer(timer);
    };
    this.disposeTimerById = timerId => {
      timers = timers.filter(({ id }) => id !== timerId);
      return this;
    };
    this.disposeTimers = () => {
      timers = [];
    };
  }
}

const timerService = new TimerService();

export { timerService, TimerService };